export function getColorFromStatusLabel(status, type, coloredBackground) {
    if (status === 'draft')
        return "black";
    else if (status === 'confirmed')
        return "green";
    else if (status === 'open') {
        if (coloredBackground) {
            return "white";
        } else if (type === "out_refund") {
            return "blue";
        } else {
            return "red"
        }
    } else if (status === 'paid')
        return "green";
    else if (status === 'cancel')
        return "black";

    return "green";
}

export function getIconNameFromStatusLabel(status) {
    if (status === 'draft')
        return "paused";
    else if (status === 'confirmed')
        return "play_arrow";
    else if (status === 'open')
        return "paused";
    else if (status === 'paid')
        return "check";
    else if (status === 'cancel')
        return "stop";

    return "play_arrow";
}

export function formatStatus(status) {
    if (status === 'draft')
        return "Brouillon";
    else if (status === 'confirmed')
        return "Confirmé";
    else if (status === 'open')
        return "En attente de règlement";
    else if (status === 'paid')
        return "Réglé";
    else if (status === 'cancel')
        return "Annulé";

    return status;
}

export function getStateColor(status) {
    return status;
}
